import axios from "axios";
import AwesomeDebouncePromise from "awesome-debounce-promise";

const searchAPI = async ({ query, url, parentId }) =>
  axios
    .get(`${url}?search=${query}${parentId ? `&parentId=${parentId}` : ""}`)
    .then(({ data }) => data.data);

export const ajaxFindLocality = AwesomeDebouncePromise(searchAPI, 500);
